import { useContext, useEffect } from 'react';
import { Box, IconButton, Typography, Skeleton, Avatar, Stack } from '@mui/material';
import { HomeOutlined, HomeWorkOutlined, AssignmentIndOutlined, Person, EmailOutlined } from "@mui/icons-material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import MenuIcon from '@mui/icons-material/Menu';
import { rqx } from '../../../../../../../core/request/API';
import { env } from '../../../../../../../core/Env';
import { ToolContext } from '../../../../../../../core/context/ToolContext';

function MobileFrame({ tLoader, children, td, company_id }) {
    const { website_state } = useContext(ToolContext);
    const { avlblePrprtyTypes } = website_state;

    const view = new URLSearchParams(window.location.search).get("view");
    const nav = useHistory();
    const menu = new URLSearchParams(window.location.search).get('menu');
    const menuVal = [
        { label: "Rent Property", icon: <HomeOutlined />, url: "property-rent" },
        { label: "Buy Property", icon: <HomeWorkOutlined />, url: "property-buy" },
        { label: "Sell Your Property", icon: <AssignmentIndOutlined />, url: "sell-your-property" },
        { label: "Be Our Agent", icon: <Person />, url: "be-our-agent" },
        { label: "Message us", icon: <EmailOutlined />, url: "message-us" },
    ]

    const handleSelectMenu = async (u) => {
        nav.push(`/campaign/website/customization?tab=mobile&menu=${u}${u === "property-rent" || u === "property-buy" ? "&property-type=all" : ""}`);
        if ( u === 'property-rent' || u === 'property-buy' )
        await getAvlblePrprtyTypes(u);
    }

    const getAvlblePrprtyTypes = async (url) => {
        avlblePrprtyTypes.set((p) => ({ ...p, loader: false }))
        try {
            const ot_id = url === 'property-rent' ? 2 : 1;
            const res = await rqx.get(`<<shp>>/${env()}/website/listproperty`, { company_id: company_id, type: 'property', offer_type: ot_id })
            const sorted_p = res?.sort((a, b) => a.id - b.id);;
            const addURL = sorted_p.map((v) => ({ ...v, url: v.name.toLowerCase() }));
            avlblePrprtyTypes.set((p) => ({ ...p, value: [{ id: 0, name: 'All', url: 'all' }, ...addURL], loader: false }))
        } catch (error) {
            console.error("Failed to fetch available types:", error);
        }
    }

    useEffect(() => {
        const fetch = async () => {
            await getAvlblePrprtyTypes('property-rent');
        }
        fetch();
        // eslint-disable-next-line
    }, [])

    const styles = {
        frame: {
            width: '100%',
            height: '100%',
            borderRadius: "22px",
            border: "9px solid",
            backgroundColor: '#fff',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
            position: 'relative',
            overflow: 'hidden',
        },
        notch: {
            width: "170px",
            height: "20.5px",
            borderRadius: '20px',
            backgroundColor: '#333',
            position: 'absolute',
            top: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
        },
        screen: {
            width: '100%',
            height: "568px",
            borderRadius: '28px',
            backgroundColor: '#f9f9f9',
            position: 'relative',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        container: {
           flexGrow: 1,
        },
        footer: {
            position: 'sticky',
            bottom: 0,
            width: '100%',
        },
    };

    return (
        <Box width="100%" style={styles.frame} >
            <Box width="100%" bgcolor="#fff" mt="45px" height="56px" display="flex" >
                <Box style={styles.notch} ></Box>   
                {
                    !tLoader.data ? (
                        <Box height="100%" width="100%" bgcolor={td.top.bg_color} p={1.5} display="flex" alignItems="center"> 
                            { view === null ?
                                <Box width="91%" height="100%" display="flex">
                                    <Box width="100%" height="100%" display="flex">
                                        <Box display="flex" justifyContent="center" alignItems="center" borderRadius={1} p={0.5}>
                                            <Avatar src={td.logo.object} alt="Logo" variant="rounded"/>
                                        </Box>
                                        <Typography
                                            color="#fff"
                                            mx={1}
                                            pr={1}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: `18px`,
                                                width: 900,
                                                wordBreak: "break-word",
                                                height: "100%",
                                                fontWeight: 500,
                                                opacity: 1,
                                                letterSpacing: "0.5px",
                                                overflow: "hidden"
                                            }}
                                        >
                                            {td.top.title.value}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <MenuIcon sx={{ color: "#fff" }}/>  
                                    </Box>
                                </Box>
                            :
                                <Box gap="8px" onClick={() => nav.goBack()} display="flex" alignItems="center" justifyContent="center" sx={{ width: 'fit-content', cursor: "pointer" }}>
                                    <KeyboardBackspaceIcon sx={{ color: '#FFFFFF' }} />
                                    <Typography fontSize="14px" color="#fff">Back</Typography>
                                </Box> 
                            }
                        </Box>
                    ) : <Skeleton variant='text' width="100%" height="100%" />
                }
            </Box>
            <Box style={styles.screen}>
                <Box flex={1} width="100%" overflow="hidden" style={styles.container}>
                    {children}
                </Box>
                <Box style={styles.footer}>
                    {!tLoader.data ?
                        (view === null && 
                            <Box display="flex" bgcolor="#fff" alignItems="center" justifyContent="space-between" p="0.1rem" sx={{ boxShadow:"rgba(0, 0, 0, 0.08) 0px -8px 16px 0px, rgba(0, 0, 0, 0.04) 0px 0px 4px 0px" }}>
                                {menuVal.map((v, i) => (
                                    <Stack key={i} direction="column"
                                        sx={{
                                            transition: "0.25s",
                                            bgcolor: menu === v.url ? `${td.site_btns.bg}4D` : "transparent",
                                            borderRadius: "8px",
                                            px: "0.3rem",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => handleSelectMenu(v.url)}
                                    >
                                        <IconButton size="small"
                                            sx={{
                                                color: menu === v.url ? td.site_btns.bg : "#808080",
                                            }}
                                        >
                                            {v.icon}
                                        </IconButton>   
                                        <Typography noWrap
                                            sx={{
                                                color: menu === v.url ? td.site_btns.bg : "#808080",
                                                fontSize: "8px",
                                            }}
                                        >
                                            {v.label}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Box>
                        )
                    :   
                        <Skeleton variant='text' sx={{
                            height: '48px',
                            borderTop: '1px solid #ddd',
                            position: 'sticky',
                            bottom: 16,
                            width: '100%',
                        }} >
                            <Box width="100%" height={200}></Box>
                        </Skeleton>
                }
                </Box>
            </Box>
        </Box>
    );
}

export default MobileFrame;